export let isInitialized = false;
export let createRoutesFromChildren;
export let matchRoutes;
export let Routes;
export let useLocation;
export let useNavigationType;
export function setReactRouterV6Dependencies(newDependencies) {
    isInitialized = true;
    createRoutesFromChildren = newDependencies.createRoutesFromChildren;
    matchRoutes = newDependencies.matchRoutes;
    Routes = newDependencies.Routes;
    useLocation = newDependencies.useLocation;
    useNavigationType = newDependencies.useNavigationType;
}
export function setReactRouterV6SSRDependencies(newDependencies) {
    Routes = newDependencies.Routes;
}
export function setReactRouterV6DataRouterDependencies(newDependencies) {
    isInitialized = true;
    matchRoutes = newDependencies.matchRoutes;
}
//# sourceMappingURL=routerDependencies.js.map